const expertLibraryCode = {
    code1: `
    <!--专家库共享抽取SDK-->
    <dependency>
        <groupId>com.cebpubservice.remotebidevaluation</groupId>
        <artifactId>cebpubservice-remotebidevaluation-java-sdk-expertlibraryshareextract</artifactId>
        <version>x.x.x(点击查看最新版本号15)</version>
    </dependency>
    <!--核心包依赖-->
    <dependency>
        <groupId>com.cebpubservice.remotebidevaluation</groupId>
        <artifactId>cebpubservice-java-sdk-core</artifactId>
        <version>x.x.x(点击查看最新版本号1)</version>
    </dependency>
    `,
    code2: `
    import com.cebpubservice.remotebidevaluation.sdk.expertlibraryshareextract.*
    import org.springframework.beans.factory.annotation.Value;
    import org.springframework.context.annotation.Configuration;
    import javax.annotation.PostConstruct;
    @Configuration
    public class ExpertLibraryShareExtractConfig {
        //评标专家库共享目录服务组件服务地址,省发改委等部署评标专家库共享目录服务组件前置机方提供
        @Value("\${serviceUrl}")
        private String serviceUrl;
        //专家库管理系统编码,通过评标专家库共享目录服务组件自助管理终端专家库信息管理页面获取
        @Value("\${expertLibraryShareCode}")
        private String expertLibraryShareCode;
        //clientld用于专家库管理系统集成SDK时设置,通过评标专家库共享目录服务组牛自助管理终端专家库信息管理页面获取
        @Value("\${clientId}")
        private String clientid;
        //clientSecret用于专家库管理系统集成SDK时设定,通过评标专家库共享目录服务组件自助管理终端专家库信息管理页面获取
        @Value("\${clientSecret}")
        private String clientSecret;
        //signatureSecret用于专家库管理系统集成SDK时设定,通过评标专家库共享目录服务组件自助管理终端专家库信息管理页面获取
        @Value("\${signatureSecret}")
        private String signatureSecret;
        @PostConstruct
        public void initExpertLibraryShare(){
            //确保此方法只在初始化时执行一次
            ExpertLibraryShareExtractSingleton.init(expertLibraryShareCode,serviceUrl,lientld,clientSecret,signatureSecret)
        }
    }
    `,
    code3: `
    <!--专家库共享抽取组件SDK-->
    <dependency>
        <groupId>com.cebpubservice.remotebidevaluation</groupId>
        <artifactId>cebpubservice-remotebidevaluation-java-sdk-conmponent-expertlibraryshareextract</artifactId>
        <version>x.x.x(点击查看最新版本号14)</version>
    </dependency>
    <!--核心包依赖-->
    <dependency>
        <groupId>com.cebpubservice.remotebidevaluation</groupId>
        <artifactId>cebpubservice-java-sdk-core</artifactId>
        <version>x.x.x(点击查看最新版本号1)</version>
    </dependency>
    `,
    code4: `
    import com.cebpubservice.remotebidevaluation.sdk.component.expertlibranryshareextract.*
    import org.springframework.beans.factory.annotation.Value;
    import org.springframework.context.annotation.Configuration;
    import javax.annotation.PostConstruct;
    @Configuration
    public class ExpertLibraryShareExtractConfig {
        //评标专家库目录服务组件服务地址,省市区县交易中心等部署评标专家库共享抽取组件前置机方提供
        @Value("\${serviceUrl}"")
        private String serviceUrl;
        //专家库共享抽取工具编码,通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置专家库共享抽取工具页面获取
        @Value("\${expertLibraryShareExtractToolCode}")
        private String expertLibraryShareExtractToolCode;
        //clientld用于专家库共享抽取工具集成SDK时设置,通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置专家库共享抽取工页面获取
        @Value("\${clientId}")
        private String clientId;
        //clientSecret用于专家库共享抽取工具集成SDK时设定,通过远程异地评标和评标和评标专家库共享目录服务组件自助管理终端设置专家库共享抽取工具页面获取
        @Value("\${clientSecret}")
        private String clientSecret;
        //signatureSecret用于专家库共享抽取工具集成SDK时设定,通过远程异地评标和评标专家库共享目录服务组件自助管理终端设置专家库共享抽取工具页面获取
        @Value("\${signatureSecret}")
        private String signatureSecret;
        @PostConstruct
        public void initExpertLibraryShareExtract(){
            //确保此方法只在初始化时执行一次
            ExpertLibraryShareExtractSingleton.init(expertLibraryShareExtractToolCode,serviceUrl,clientld,clientSecret,signatureSecret);
        }
    }
    `,
}

export default expertLibraryCode